import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import { NodeDetailsDto } from "domains/nodes/components/common/NodeDetailsDto";
import localisation from "../../../../localisation";

interface IProps {
    nodeDetails: NodeDetailsDto;
    "aria-label": string;
    onEdit: (newNodeDetails: NodeDetailsDto) => void;
}

const EditableNodeDetails = (props: IProps) => {
    const { nodeDetails, onEdit } = props;

    const { nodeName, nodeReference, allowPartions } = localisation.nodeDetails.fields;

    const [internalNodeDetails, setNodeDetails] = useState<NodeDetailsDto>(nodeDetails);

    useEffect(() => {
        onEdit(internalNodeDetails);
    }, [internalNodeDetails]);

    return (
        <form aria-label={props["aria-label"]}>
            <TextField
                inputProps={{
                    "aria-labelledby": nodeName.labelText,
                }}
                autoComplete="off"
                required
                label={nodeName.labelText}
                helperText={nodeName.helperText}
                fullWidth
                margin="normal"
                value={internalNodeDetails.name ?? ""}
                onChange={(e) => setNodeDetails({ ...internalNodeDetails, name: e.target.value })}
            />
            <TextField
                inputProps={{
                    "aria-labelledby": nodeReference.labelText,
                }}
                autoComplete="off"
                label={nodeReference.labelText}
                helperText={nodeReference.helperText}
                fullWidth
                margin="normal"
                value={internalNodeDetails.reference ?? ""}
                onChange={(e) => setNodeDetails({ ...internalNodeDetails, reference: e.target.value })}
            />
            <FormControlLabel
                sx={{ pl: 1, pb: 1 }}
                name={allowPartions.helperText}
                control={
                    <Checkbox
                        checked={internalNodeDetails.allowPartitions}
                        onChange={() =>
                            setNodeDetails({
                                ...internalNodeDetails,
                                allowPartitions: !internalNodeDetails.allowPartitions,
                            })
                        }
                        value={internalNodeDetails.allowPartitions}
                    />
                }
                label={allowPartions.helperText}
            />
        </form>
    );
};

export default EditableNodeDetails;
